<template>
    <!--    <div>-->
    <!--        <sidebar></sidebar>-->
    <!-- Begin page -->
    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
            <flash-messages></flash-messages>
            <slot/>
            <div v-if="$page.props.flash.order && show" class="warning notification" :class="{show: show}">
                {{ $page.props.flash.order }}
            </div>
        </div>
        <audio src="/audio.mp3" id="audio" controls style="display: none"></audio>
    </div>
    <!--    </div>-->
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
// import Sidebar from '@/Shared/Sidebar';

export default {
    name: "Layout",
    components: {
        FlashMessages,
        // Sidebar,
    },
    data: () => {
        return {
            show: false
        }
    },
    async mounted() {
        window.Echo.private(`App.Models.Admin.${this.$page.props.auth.user.id}`).notification((notification) => {
            console.log("new order came in from layout");
            this.$page.props.flash.success = "New Order Came In";
            this.show = true
            setTimeout(() => {
                this.show = this.show ? !this.show : this.show
            }, 4000)
            this.playNotificationSound()
        });
    },
    methods: {
        playNotificationSound(){
            document.getElementById('audio').play();
            // const audio = new Audio('/notification.wav');
            // this.$nextTick(() => {
            //     audio.play();
            // });
        },
    }

}
</script>

<style>
.vgt-table td {
    border-right: 1px solid #dcdfe6;

}
</style>
